import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Box, Button, Grid } from "@mui/material";
import { useMemo } from "react";
import { useDocumentationUIContext } from "../DocumentationUIContext";

export function DocumentationToolbar() {
  const documentationUIContext = useDocumentationUIContext();
  const documentationUIProps = useMemo(() => {
    return {
      goToCreateDocumentation: documentationUIContext.gotoCreateDocumentation,
    };
  }, [documentationUIContext]);
  const { goToCreateDocumentation } = documentationUIProps;

  return (
    <Box>
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          m: -1,
        }}
      >
        <h1 className="pages-title">
          <u>Pengaturan Dokumentasi</u>
        </h1>
        <Grid
          sx={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Box sx={{ m: 1 }}>
            <Button
              color="primary"
              variant="contained"
              onClick={goToCreateDocumentation}
              startIcon={<AddCircleOutlineIcon />}
              title="Tambah Data Dokumentasi"
            >
              Tambah Dokumentasi
            </Button>
          </Box>
        </Grid>
      </Box>
      <Box sx={{ mt: 3 }}></Box>
    </Box>
  );
}
